// #region Imports
import { useCallback, useEffect, useState } from 'react';
import { listProdutos, createProduto, updateProduto, deleteProduto, getAllProdutos } from '../services/produtosApi';
import { computeStats } from '../pages/Produtos/produtos-utils';
// #endregion

// #region Constantes
const FILTERS_KEY = 'produtos.filters.v1';
// #endregion

// #region Persistência de filtros
function loadPersisted() {
  try { return JSON.parse(localStorage.getItem(FILTERS_KEY)) || {}; } catch { return {}; }
}
function persistFilters(f) { localStorage.setItem(FILTERS_KEY, JSON.stringify(f)); }
// #endregion

export function useProdutos() {
  // #region Estado base
  const persisted = loadPersisted();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(persisted.page || 1);
  const pageSize = 10; // fixo
  const [searchDraft, setSearchDraft] = useState(persisted.search || '');
  const [search, setSearch] = useState(persisted.search || '');
  const [stats, setStats] = useState({ total_produtos: 0, produtos_baixo_estoque: 0, valor_total_estoque: 0 });
  // #endregion

  // #region Efeitos / Refresh
  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const { items, total } = await listProdutos({ search, page, pageSize });
      const totalPages = Math.max(1, Math.ceil(total / pageSize));
      if (page > totalPages) {
        setPage(totalPages);
        return; // efeito dispara novo refresh
      }
      setItems(items);
      setTotal(total);
      const all = await getAllProdutos();
      setStats(computeStats(all));
      persistFilters({ search, page });
    } finally {
      setLoading(false);
    }
  }, [search, page, pageSize]);
  useEffect(() => { refresh(); }, [refresh]);
  // #endregion

  // #region Handlers filtros
  function commitSearch() { setPage(1); setSearch(searchDraft.trim()); }
  function onChangeSearch(v) { setSearchDraft(v); }
  // #endregion

  // #region Handlers CRUD
  async function saveProduto(form) {
    const idNum = form.id != null && form.id !== '' ? Number(form.id) : null;
    const payload = {
      ...form,
      id: idNum,
      preco_venda: Number(form.preco_venda),
      estoque_atual: Number(form.estoque_atual),
      estoque_min: Number(form.estoque_min),
    };
    if (idNum && !Number.isNaN(idNum)) await updateProduto(idNum, payload);
    else await createProduto({ ...payload, id: undefined });
    await refresh();
  }
  async function removeProduto(id) {
    await deleteProduto(id);
    const nextTotal = total - 1;
    const totalPages = Math.max(1, Math.ceil(nextTotal / pageSize));
    if (page > totalPages) setPage(totalPages); else await refresh();
  }
  // #endregion

  // #region Export
  return {
    loading,
    items,
    total,
    page,
    pageSize,
    setPage,
    searchDraft,
    onChangeSearch,
    commitSearch,
    stats,
    saveProduto,
    removeProduto,
    refresh,
  };
  // #endregion
}